import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "react-intl-tel-input/dist/main.css";
import CustomPhoneInput from "../PhoneInput/PhoneInput1";
import RequiredLabel from "../Common/RequiredLabel/RequiredLabel";
import { isMobileNumberValid } from "../../Services/CommonFunction";
import { Label } from "../Common/Label/Label";
import WebService from "../../Services/WebService";
import HelperService from "../../Services/HelperService";
import { toast } from "react-toastify";

interface ChangeMobileNumberModalProps {
    show: boolean;
    onHide: () => void;
    onSave: (dialCode: string, mobile: string, country_code1: string) => void;
    defaultDialCode: string,
    mode:string
}

const ChangeMobileNumberModal: React.FC<ChangeMobileNumberModalProps> = ({
    show,
    onHide,
    onSave, defaultDialCode,mode
}) => {
    const [dialCode, setDialCode] = useState(defaultDialCode);
    const [mobile, setMobile] = useState("");
    const [countryCode, setCountryCode] = useState("")
    const [errorFlag, setErrorFlag] = useState(false);
    useEffect(() => {
        if (defaultDialCode) {
            setDialCode(defaultDialCode)
        }
    }, [defaultDialCode])

    const handleSave = () => {
        if (mobile === `+${dialCode}` ||
            !isMobileNumberValid(
                mobile,
                dialCode)
        ) {
            setErrorFlag(true);
            return
        }
        setErrorFlag(false)
        handleChangeMobile()
    };
    const handleChangeMobile = () => {
        WebService.addLoader("save_change_mobile")
        return WebService.postAPI({
            action: `change-phone/request`,
            body: {
                dial_code: dialCode,
                mobile_number: HelperService.removeDialCode(
                    mobile,
                    dialCode
                ),
                country_code: countryCode,
                has_resent: 0
            },
            isShowError: false,
        })
            .then((res: any) => {
                if (res?.status) {
                    toast.success(res?.message);
                    onSave(dialCode, mobile, countryCode)
                    handleHide()
                } else {
                    toast.error(res.message);
                }
            })
            .catch((error: any) => {
                toast.error(error?.response?.data?.message);
                WebService.removeLoader("save_basic_details");
                return error;
            }).finally(() => {
                WebService.removeLoader("save_change_mobile")
            })

    }
    const handleHide = () => {
        setErrorFlag(false)
        // setDialCode("");
        setMobile("");
        setCountryCode("")
        onHide()
    }

    const handlePhoneChange = (value: any, countryData: any) => {

        setCountryCode(countryData.iso2)
        setMobile(value)
        setDialCode(countryData?.dialCode)
    };

    return (
        <Modal show={show} onHide={handleHide} centered >
            <Modal.Header closeButton>
                <Modal.Title>{HelperService?.ProperCase(mode??"")} Mobile Number</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <RequiredLabel isRequired={true}>
                    Enter New Mobile Number
                </RequiredLabel>
                <div className="mt-2">
                    <CustomPhoneInput
                        dial_code={dialCode}
                        value={mobile}
                        errorFlag={errorFlag}
                        handlePhoneNumberChange={(value: any, countryData: any) => handlePhoneChange(value, countryData)
                        }
                    />
                    {errorFlag &&
                        (mobile === `+${dialCode}` || !isMobileNumberValid(
                            mobile,
                            dialCode
                        )) && (
                            <Label
                                title="Please enter mobile number"
                                modeError={true}
                            />
                        )}</div>
                <div className="d-flex justify-content-center gap-3 mt-3">
                    <Button variant="secondary" onClick={handleHide}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSave} id="save_change_mobile">
                        Save
                    </Button>
                </div>

            </Modal.Body>


        </Modal>
    );
};

export default ChangeMobileNumberModal;
